// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-1A-mu";
var _3 = "small-1aOpj";
var _4 = "option-rEZIj";
var _5 = "big-1pI5_";
export { _1 as "__esModule", _2 as "root", _3 as "small", _4 as "option", _5 as "big" }
export default { "__esModule": _1, "root": _2, "small": _3, "option": _4, "big": _5 }
